"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptationTechnology = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var AdaptationTechnology = (function (_super) {
    __extends(AdaptationTechnology, _super);
    function AdaptationTechnology() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ADAPTATION_TECHNOLOGY,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 12,
            metadata: {
                cardNumber: '153',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('Your global requirements are +2 or -2 steps, your choice in each case.', function (eb) {
                        eb.plate('Global requirements').startEffect.text('+/- 2');
                    });
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    AdaptationTechnology.prototype.getRequirementBonus = function () {
        return 2;
    };
    AdaptationTechnology.prototype.play = function () {
        return undefined;
    };
    AdaptationTechnology.prototype.getVictoryPoints = function () {
        return 1;
    };
    return AdaptationTechnology;
}(Card_1.Card));
exports.AdaptationTechnology = AdaptationTechnology;
//# sourceMappingURL=AdaptationTechnology.js.map